<script setup>
import ActionButton from "@/components/ui/ActionButton.vue";
import {computed, defineProps} from "vue"
import {useRouter} from "vue-router";
import {useCartTools} from "@/composables/cart-tools";
import environment from "@/environment";


const props = defineProps({
  item: {type: Object, required: true},
})
const router = useRouter();
const {addCartHandler} = useCartTools();

const isCoin = computed(() => {
  return props.item.category_id === environment.appConfig.coinCategory
});
const checkoutCaption = computed(() => {
  return isCoin.value ? 'Выбрать' : 'В корзину';
})

function orderHandler() {
  if(!isCoin.value) {
    addCartHandler(props.item)
    return;
  }
  shopCardClickHandler();
}

function shopCardClickHandler() {
  router.push({name: 'ProductCardView', query: {priceListItemId: props.item.id}})
}

function thumbnailUrl(url) {
  return url?.replace('variant=display', 'variant=thumbnail') || url;
}

</script>

<template>
  <div class="shopCard"
       @click.stop.prevent="shopCardClickHandler"
  >
    <div class="shopCard__wrapper">
      <img
          v-if="item.img_url"
          alt=""
          class="shopCard__image"
          :src="thumbnailUrl(item.img_url)"
          @error="(e)=> e.target.src = require('@/assets/img/preview_placeholder.jpg')"
      >
      <img
          v-else
          alt=""
          class="shopCard__image"
          :src="require('@/assets/img/preview_placeholder.jpg')"
      >
      <div class="shopCard__name">{{item.name}}</div>
      <div class="shopCard__price">
        {{item.sale_price}}Р
        <span
            class="shopCard__oldPrice"
            v-if="item.old_price"
        >
          {{item.old_price}}Р
        </span>
      </div>
      <div class="shopCard__spacer"></div>
      <div class="shopCard__button">
        <ActionButton style="width: 100%" @button-click="orderHandler">
          <template #caption>{{checkoutCaption}}</template>
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.shopCard {
  border-radius: var(--cd-card-border-radius);
  background-color: var(--cd-card-bg);
  width: 256px;
  min-width: 200px;
  max-width: 100%;
  height: 410px;

  @include respond-to('sm') {
    width: 100%;
    height: auto;
  }

  &__wrapper {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 10px 10px 20px;
    gap: 6px;
    margin: 0 auto;
    height: 100%;
  }

  &__name {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    text-wrap: nowrap;
    max-width: 100%;
    flex-shrink: 0;
  }

  &__button {
    width: 100%;
  }

  &__spacer {
    flex-grow: 1;
    height: 100%;
  }

  &__image {
    border-radius: var(--cd-card-border-radius);
    width: 100%;
    height: 220px;
    object-fit: cover;
    object-position: center;

    @include respond-to('sm') { height: 200px; }
  }

  &__oldPrice {
    color: var(--cd-text-muted);
    text-decoration: line-through;
  }
}
</style>
